// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__j46Z3","noInteraction":"EventWrapper_noInteraction__3IJsL","pointerPassthrough":"EventWrapper_pointerPassthrough__3qrv1"};